import styled, { css } from 'styled-components';
import { calculateZoom } from '../../../../store/form/utils';

export interface PreviewProps {
  $width: number;
  $height: number;
  $zoom?: number;
  $backgroundImage?: string | null;
}

export const FormBannerPreview = styled.div`
  background-color: #ececec;
  border-radius: 10px;
  width: 100%;
  height: -webkit-fill-available;
  user-select: none;
`;

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  font-size: 30px;
  color: #513389;
`;

export const Label = styled.label`
  display: flex;
  margin: auto 0;
`;

export const BannerPreviewContainer = styled.div<any>`
  ${() => css`
    position: relative;
    background-color: transparent;
    transition:
      min-height 500ms,
      max-height 500ms;
    height: 100%;
    text-align: center;
  `}
`;
//
export const BannerPreviewContent = styled.div<PreviewProps>`
  ${({ $height, $zoom, $backgroundImage }) => css`
    position: relative;
    min-height: ${$height}px;
    max-height: ${$height}px;
    ${$backgroundImage
      ? `
     background-image: url("${$backgroundImage}");
     background-size: 100% 100%;
     background-repeat: no-repeat;
     `
      : ``}

    transform: scale(${$zoom ? calculateZoom(0.1, 3, $zoom) : 1});
    width: -webkit-fill-available;
    overflow: hidden;
  `}
`;

export const SliderContainerWrapper = styled.div`
  display: flex;
  /* align-items: center; */
  min-width: 36%;
`;
